"use client";

import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { type CategoryItem } from "./marketplace-helpers";
import { type MarketplaceFilter } from "@/types/integrations";

export default function Sidebar({
  categories,
  selectedCategory,
  onCategoryChange,
}: Readonly<{
  categories: CategoryItem[];
  selectedCategory: MarketplaceFilter;
  onCategoryChange: (cat: MarketplaceFilter) => void;
}>) {
  const { t } = useTranslation("partners");

  return (
    <nav className="space-y-0.5">
      {categories.map((cat) => {
        const isActive = selectedCategory === cat.id;
        return (
          <button
            key={cat.id}
            onClick={() => onCategoryChange(cat.id)}
            className={clsx(
              "w-full px-2.5 py-2 rounded-lg text-sm text-left transition-all duration-300",
              isActive
                ? "bg-gailBlue/10 text-gailBlue font-medium"
                : "text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700"
            )}
          >
            {t(cat.labelKey)}
          </button>
        );
      })}
    </nav>
  );
}
